module.exports = __webpack_public_path__ + "img/aqpx.2e5fd6e7.svg";